import { BaseModel } from '@Core';
import { Camera } from './Camera';

export interface PTZPresets extends BaseModel {
    CameraId: number;
    Camera?: Camera;
    PresetName: string;
    PresetId: number;
    PtzPanPos: string;
    PtzTiltPos: string;
    PtzZoomPos: string;
    Status: Status;
    ViewName?: string;
    Mapper?: string;
    LastSynced?: Date;
    LastUpdatedPtz?: Date;
    LastMapped?: Date;
}

export enum Status {
    Mapped,
    Unmapped,
}
